module.exports = __webpack_public_path__ + "img/2.b9c31627.svg";